<template>
    <div class="popularize">
        <img class="top-banner" :src="`${GET_STATIC_IMG_HOST}popularize/others/banner3.jpg`">
        <div class="content-wrapper">
            <div class="top-context">
                <p>大冰《好吗好的》、张爱玲《倾城之恋》、当年明月《明朝那些事儿》、琼瑶</p>
                <p>《水云间》……</p>
                <p>这些大热的作品，都在虚位以待，等你来演绎</p>
                <p>加入我们，用你独有的声音，为他们诠释出不一样的色彩</p>
                <p style="font-size: 32px;padding:45px 0 60px;">- 欢迎作品入驻 -</p>
                <p>如果您是拥有文字作品的作者或版权方</p>
                <p>希望将文字作品有声化</p>
                <p>随时欢迎加入平台</p>
                <p>这里将有众多主播给美丽的文字带上声音的翅膀</p>
            </div>
            <div class="separate-line"></div>
            <div class="sections">
                <div style="padding: 0;" class="section-wrapper">
                    <span class="title">- 男生小说 -</span>
                    <div style="padding: 20px 50px 70px 20px;border-right: 1px solid #d9d9d9;" class="works-wrapper">
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/酒局.jpg`">
                            <span>酒局</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/采珠勿惊龙.jpg`">
                            <span>采珠勿惊龙</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/守夜者.jpg`">
                            <span>守夜者</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/天影.jpg`">
                            <span>天影</span>
                        </div>
                    </div>
                </div>
                <div style="padding: 0;" class="section-wrapper">
                    <span class="title">- 经典出版物 -</span>
                    <div class="works-wrapper" style="padding: 20px 20px 70px 50px;">
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/你若安好便是晴天.jpg`">
                            <span>你若安好便是晴天</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/平易近人.jpg`">
                            <span>平易近人</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/万物和你一样动人.jpg`">
                            <span>万物和你一样动人</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/美洲小宇宙.jpg`">
                            <span>美洲小宇宙</span>
                        </div>
                    </div>
                </div>
                <div style="border-bottom: 0;padding-top: 45px;padding-right:50px;border-right: 1px solid #d9d9d9;" class="section-wrapper">
                    <span class="title">- 女生小说 -</span>
                    <div class="works-wrapper">
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/半生缘.jpg`">
                            <span>半生缘</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/水云间.jpg`">
                            <span>水云间</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/一帘幽梦.jpg`">
                            <span>一帘幽梦</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/红玫瑰与白玫瑰.jpg`">
                            <span>红玫瑰与白玫瑰</span>
                        </div>
                    </div>
                </div>
                <div style="border-bottom: 0;padding-top: 45px;padding-left: 50px;" class="section-wrapper">
                    <span class="title">- 经典文学 -</span>
                    <div class="works-wrapper">
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/呼啸山庄.jpg`">
                            <span>呼啸山庄</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/忏悔录.jpg`">
                            <span>忏悔录</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/沉思录.jpg`">
                            <span>沉思录</span>
                        </div>
                        <div class="work">
                            <img :src="`${GET_STATIC_IMG_HOST}popularize/day3/神曲.jpg`">
                            <span>神曲</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="cooperator-wrapper">
                <span class="title">- 众多合作商已倾情加盟 -</span>
                <div class="cooperator-list">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-01.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-02.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-03.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-04.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-05.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-06.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-07.png`">
                    <img :src="`${GET_STATIC_IMG_HOST}popularize/logo/logo-08.png`">
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="more-wrapper">
                <span class="title">- 了解更多 -</span>
                <div class="links-wrapper">
                    <router-link class="link" :to="{name: 'idols'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/大神云集@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'classic'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/经典汇聚@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'benefits'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/福利体系@2x.png`"></router-link>
                </div>
            </div>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-bottom">立即加入</router-link>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-fixed">立即加入</router-link>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    methods: {
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台首页"
        }),
          xmLog("pv.send", "event", {
            serviceId: "aBookView",
            item: "有声化推广页_海量作品库"
          })
      }
    },
    computed: {
      GET_STATIC_IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    },
    mounted () {

      // 埋点
      this.setXMLog ();
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/popularize/popularize-first.scss";
</style>



// WEBPACK FOOTER //
// WorkLib.vue?40d13c02